(function () {

    angular
        .module('smartertoolsApp')
        .controller('resellersController', ['$scope', '$q', '$timeout', 'resellersService', 'cacheControl', 'notificationFactory', 'authenticationService', 'licenseKeyService', resellersController]);

    function resellersController($scope, $q, $timeout, resellersService, cacheControl, notify, authenticationService, licenseKeyService) {
        const vm = this;
        vm.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        vm.paging = {
            customers: {
                currentPage: 1,
                itemsPerPage: 10,
                search: '',
                reverse: false,
                sortKey: 'EmailAddress',
                filteredCount: 0,
                filteredItems: null,
                recalc: function () {
                    $timeout(() => {
                        vm.paging.customers.filteredCount = vm.paging.customers.filteredItems
                            ? vm.paging.customers.filteredItems.length
                            : 0;
                    }, 10);
                },
                doSort: function (keyName) {
                    vm.paging.customers.reverse = vm.paging.customers.sortKey !== keyName || !vm.paging.customers.reverse;
                    vm.paging.customers.sortKey = keyName;
                }
            },
            licenses: {
                currentPage: 1,
                itemsPerPage: 10,
                search: '',
                reverse: true,
                sortKey: 'DatePurchasedUtc',
                filteredCount: 0,
                filteredItems: null,
                recalc: function () {
                    $timeout(() => {
                        vm.paging.licenses.filteredCount = vm.paging.licenses.filteredItems
                            ? vm.paging.licenses.filteredItems.length
                            : 0;
                    }, 10);
                },
                doSort: function (keyName) {
                    vm.paging.licenses.reverse = vm.paging.licenses.sortKey !== keyName || !vm.paging.licenses.reverse;
                    vm.paging.licenses.sortKey = keyName;
                }
            }
        };
        vm.agreement = { subject: '', body: '', type: '', isAccepted: false };

        // Functions
        vm.assignLicense = assignLicense;
        vm.assignSpecificLicense = assignSpecificLicense;
        vm.attachFocusEvents = attachFocusEvents;
        vm.generateShortNameForLicense = generateShortNameForLicense;
        vm.getCustomerCsvData = getCustomerCsvData;
        vm.getCustomerCsvHeader = getCustomerCsvHeader;
        vm.getUnassignedLicenseCsvData = getUnassignedLicenseCsvData;
        vm.getUnassignedLicenseCsvHeader = getUnassignedLicenseCsvHeader;
        vm.isUpgradeProtectionActive = isUpgradeProtectionActive;
        vm.refreshData = refreshData;
        vm.resendCustomerLicenseEmail = resendCustomerLicenseEmail;
        vm.selectCustomer = selectCustomer;
        vm.selectCustomerLicense = selectCustomerLicense;
        vm.selectLicense = selectLicense;
        vm.showAssignModal = showAssignModal;
        vm.showAssignSpecificLicense = showAssignSpecificLicense;
        vm.showTermsAgreementOverlay = showTermsAgreementOverlay;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refreshData(true);
        }

        // Implementation
        function assignLicense() {
            if (vm.assignLicenseForm.$invalid || vm.isSending)
                return;
            vm.isSending = true;
            resellersService.assignLicense(vm.assignLicenseKey.LicenseKey, vm.assignEmail)
                .then((data) => {
                    vm.modalPage = 'email-sent';
                    vm.isSending = false;
                    licenseKeyService.clearCache();
                    vm.refreshData(true);
                });
        }

        function assignSpecificLicense() {
            if (vm.assignSpecificLicenseForm.$invalid || vm.isSending)
                return;
            vm.isSending = true;
            resellersService.assignLicense(vm.selectedLicense.LicenseKey, vm.assignEmail)
                .then((data) => {
                    vm.modalPage = 'email-sent';
                    vm.isSending = false;
                    licenseKeyService.clearCache();
                    vm.refreshData(true);
                });
        }

        function attachFocusEvents() {
            if (!vm.focusEventsAttached) {
                document.getElementById('reseller-assign-modal').addEventListener('shown.bs.modal', () => { document.getElementById('assignlicensekey').focus(); });
                vm.focusEventsAttached = true;
            }
        }

        function generateShortNameForLicense(lic) {
            const formattedDate = moment(lic.DatePurchasedUtc).format('l');
            return `${lic.Product} (purchased ${formattedDate})`;
        }

        function getCustomerCsvData() {
            const items = [];
            for (let i = 0; i < vm.customers.length; i++) {
                const item = vm.customers[i];
                for (let j = 0; j < item.Licenses.length; j++) {
                    const license = item.Licenses[j];
                    items.push([
                        item.EmailAddress,
                        item.Name,
                        item.company,
                        license.LicenseKey,
                        license.Product,
                        moment(license.DatePurchasedUtc).format(),
                        license.DateAssignedUtc ? moment(license.DateAssignedUtc).format() : null,
                        license.DateUpgradeProtectionExpiresUtc
                            ? moment(license.DateUpgradeProtectionExpiresUtc).format()
                            : null,
                        license.InvoiceId,
                        license.MaxBuild
                    ]);
                }
            }
            return items;
        }

        function getCustomerCsvHeader() {
            return [
                'Email Address', 'Name', 'Company', 'License Key', 'Product', 'Purchased', 'Assigned',
                'Maintenance and Support Expires', 'Original Invoice #', 'Max Build'
            ];
        }

        function getUnassignedLicenseCsvData() {
            const items = [];
            for (let j = 0; j < vm.unassignedLicenses.length; j++) {
                const license = vm.unassignedLicenses[j];
                items.push({
                    lk: license.LicenseKey,
                    product: license.Product,
                    purchased: moment(license.DatePurchasedUtc).format(),
                    invoice: license.InvoiceId
                });
            }
            return items;
        }

        function getUnassignedLicenseCsvHeader() {
            return ['License Key', 'Product', 'Purchased', 'Original Invoice #'];
        }

        function isUpgradeProtectionActive(license) {
            if (license == null || !license.DateUpgradeProtectionExpiresUtc)
                return false;
            return (new Date(license.DateUpgradeProtectionExpiresUtc) > new Date());
        }

        function refreshData(clearCache) {
            if (clearCache) {
                cacheControl.getCache('resellerCache').removeAll();
            }
            $scope.accountCtrl.isLoading += 2;
            $q.all(
                [
                    resellersService.getUnassignedLicenses(),
                    resellersService.getCustomers()
                ])
                .then((values) => {
                    $scope.accountCtrl.isLoading -= 2;
                    vm.unassignedLicenses = values[0];
                    vm.paging.licenses.recalc();
                    vm.customers = values[1];

                    //if (vm.isAccepted == false)
                    //	vm.showTermsCondition();
                    authenticationService.showTermsCondition(
                        (data) => {
                            const showAgreement = data;
                            if (showAgreement == true) {
                                ShowTermsAgreementOverlay();
                            }
                        });
                    vm.paging.customers.recalc();
                    $scope.$applyAsync();
                })
                .catch((e) => {
                    if (e.status == 403) {
                        window.location.href = '/company/partners';
                        return;
                    }
                    $scope.accountCtrl.isLoading -= 2;
                    notify.error('There was a problem loading this information.  Please try again later.');
                });
        }

        function resendCustomerLicenseEmail() {
            vm.isSending = true;
            resellersService.resendLicenseEmail(vm.selectedCustomerLicense.LicenseKey)
                .then((data) => {
                    vm.modalPage = 'email-sent';
                    vm.isSending = false;
                });
        }

        function selectCustomer(customer) {
            vm.modalPage = 'start';
            vm.selectedCustomer = customer;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('reseller-customer-view-modal')).show();
        }

        function selectCustomerLicense(license) {
            vm.modalPage = 'license-detail';
            vm.selectedCustomerLicense = license;
        }

        function selectLicense(license) {
            vm.modalPage = 'start';
            vm.selectedLicense = license;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('reseller-license-view-modal')).show();
        }

        function showAssignModal() {
            vm.modalPage = 'start';
            vm.isSending = false;
            vm.assignLicenseKey = null;
            vm.assignEmail = null;
            vm.assignEmailConfirm = null;
            vm.assignLicenseForm.$setPristine();
            vm.assignLicenseForm.$setUntouched();
            vm.attachFocusEvents();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('reseller-assign-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function showAssignSpecificLicense() {
            vm.modalPage = 'assign';
            vm.isSending = false;
            vm.assignEmail = null;
            vm.assignEmailConfirm = null;
            vm.assignSpecificLicenseForm.$setPristine();
            vm.assignSpecificLicenseForm.$setUntouched();
            $timeout(() => {
                RecalculateAllFloatLabelControls();
                document.getElementById('assignSpecificEmail').focus();
            });
        }

        function showTermsAgreementOverlay() {
            authenticationService.getAgreement((data) => {
                vm.agreement.body = data.Body;
                vm.agreement.subject = data.Subject;
                vm.agreement.type = data.Type;
                bootstrap.Modal.getOrCreateInstance(document.getElementById('partner-agreement-resource')).show();
            });
        }
    }

})();